module.exports = __webpack_public_path__ + "img/HC2012-152.a95104b9.jpg";